import React from "react";
import { Heart } from "lucide-react";
import { FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";
import { BRAND, waOrder } from "../../data/zingly";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1E1E1E] text-white pt-16 pb-8 overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#F58220] via-[#E16608] to-[#F58220]" />
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-14 h-14 rounded-full overflow-hidden bg-white shadow-lg ring-2 ring-[#F58220]/40">
                <img src={BRAND.logo} alt="Zingly Dosa" className="w-full h-full object-cover" />
              </span>
              <div className="flex flex-col leading-tight">
                <span className="font-serif text-2xl font-extrabold">
                  Zingly <span className="text-[#F58220]">Dosa</span>
                </span>
                <span className="text-[10px] uppercase tracking-[0.18em] text-[#F58220] font-semibold">
                  Home Made • Fresh Daily
                </span>
              </div>
            </div>
            <p className="mt-4 text-white/70 text-sm leading-relaxed max-w-sm">
              Homemade South Indian Food — Fresh batter every day, crispy dosas, soft idlis,
              and authentic flavours from Beed, Maharashtra.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={waOrder()}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#25D366] flex items-center justify-center transition"
                data-testid="footer-whatsapp"
              >
                <FaWhatsapp className="w-4 h-4" />
              </a>
              <a
                href="https://instagram.com/zinglydosa"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#F58220] flex items-center justify-center transition"
                data-testid="footer-instagram"
              >
                <FaInstagram className="w-4 h-4" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#F58220] flex items-center justify-center transition"
                data-testid="footer-facebook"
              >
                <FaFacebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#menu" className="hover:text-[#F58220] transition">Our Menu</a></li>
              <li><a href="#about" className="hover:text-[#F58220] transition">About Us</a></li>
              <li><a href="#reviews" className="hover:text-[#F58220] transition">Reviews</a></li>
              <li><a href="#contact" className="hover:text-[#F58220] transition">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg font-bold mb-4">Visit Us</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>{BRAND.location}</li>
              <li>{BRAND.hours}</li>
              <li>
                <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-[#F58220] transition">
                  {BRAND.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/60">
            © {new Date().getFullYear()} Zingly Dosa. All rights reserved.
          </div>
          <div className="text-xs text-white/60 flex items-center gap-1.5">
            Made with <Heart className="w-3.5 h-3.5 text-[#F58220] fill-[#F58220]" /> in Beed, Maharashtra
          </div>
        </div>
      </div>
    </footer>
  );
};
